module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-8.08a3d4d6.jpg";